module.exports = __webpack_public_path__ + "img/插画@2x.b79582b7.png";